import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class KycAuthGuardClass  {
  constructor( 
    private toastr: ToastrService,
    private authService: AuthService,
    private router: Router ) {  }

    canActivate(route: ActivatedRouteSnapshot) {
    //   if (this.authService.hasUtility()){
    //     this.toastr.error("You don't have permission.");
    //     this.router.navigate(['']);
    //     return false;
    //   }
      
      if (!this.authService.isLoggedIn()) 
      {
        this.toastr.error("You don't have permission.");
        return false;
      }
      var admin = localStorage.getItem('isAdmin');
      if (admin != '0') {
        return false;
      }
       return true;
    }
}

export const KycAuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot): boolean => {
  return inject(KycAuthGuardClass).canActivate(next);
}